/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Checkin_LabelInputs */

const en_us2_profile_checkin_label = /** @type {(inputs: Profile_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morning check-in`)
};

const pt_br2_profile_checkin_label = /** @type {(inputs: Profile_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in matinal`)
};

const es_419_profile_checkin_label = /** @type {(inputs: Profile_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in de la mañana`)
};

const pt_pt2_profile_checkin_label = /** @type {(inputs: Profile_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in da manhã`)
};

const fr_fr2_profile_checkin_label = /** @type {(inputs: Profile_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilan du matin`)
};

const de_de2_profile_checkin_label = /** @type {(inputs: Profile_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morgen-Check-in`)
};

const it_it2_profile_checkin_label = /** @type {(inputs: Profile_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in del mattino`)
};

/**
* | output |
* | --- |
* | "Morning check-in" |
*
* @param {Profile_Checkin_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_checkin_label = /** @type {((inputs?: Profile_Checkin_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Checkin_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_checkin_label(inputs)
	if (locale === "es-419") return es_419_profile_checkin_label(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_checkin_label(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_checkin_label(inputs)
	if (locale === "de-DE") return de_de2_profile_checkin_label(inputs)
	if (locale === "it-IT") return it_it2_profile_checkin_label(inputs)
	return en_us2_profile_checkin_label(inputs)
});
export { profile_checkin_label as "profile.checkin_label" }